import { useState } from 'react';
import {
  Flex,
  Box,
  Text,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Select,
} from '@chakra-ui/react';
import Link from 'next/link';
import { useMediaQuery } from '@chakra-ui/media-query';
import ChakraMarkdown from '../components/ChakraMarkdown';
import Layout from '../components/Layout';
import Seo from '../components/Seo';
import CustomButton from '../components/CustomButton';
import { bundles, languages } from '../lib/data';
import { GET_PRODUCT_BRIEFING_BUNDLE } from '../apollo/queries/GetProductBriefingBundle';
import { useQuery } from '@apollo/client';

const ProductBriefingBundles = ({ global }) => {
  const [language, setLanguage] = useState('en');
  const [isLargerThan1024] = useMediaQuery('(min-width: 1024px)');

  const { data, loading, error } = useQuery(GET_PRODUCT_BRIEFING_BUNDLE, {
    context: { clientName: 'strapi' },
    fetchPolicy: 'cache-first',
  });

  return (
    <Layout global={global}>
      <Seo seo={{}} />
      <Flex
        direction="column"
        maxW={720}
        margin={isLargerThan1024 ? '4rem auto' : '4rem 2rem'}
      >
        {!loading && (
          <Box>
            <Text fontSize="1.1rem" lineHeight="1.7" my={10}>
              {data.productBrefingBundle.data.attributes.shortDescription}
            </Text>
            <Text
              fontSize="1.6rem"
              fontWeight="700"
              color="#006067"
              textAlign="center"
              my={10}
            >
              {data.productBrefingBundle.data.attributes.section_one.title}
            </Text>
            <ChakraMarkdown
              content={
                data.productBrefingBundle.data.attributes.section_one.content
              }
              onLinkClick={() => null}
            />
            <Text
              fontSize="1.6rem"
              fontWeight="700"
              color="#006067"
              textAlign="center"
              my={10}
            >
              {data.productBrefingBundle.data.attributes.section_two.title}
            </Text>
            <ChakraMarkdown
              content={
                data.productBrefingBundle.data.attributes.section_two.content
              }
              onLinkClick={() => null}
            />
          </Box>
        )}
      </Flex>
      <Flex
        backgroundColor="gray.100"
        direction="column"
        justifyContent="center"
        alignItems="center"
        h={200}
      >
        <Text textAlign="center" fontSize="1.4rem" fontWeight="400">
          To trial any of our bundles, just get in touch.
        </Text>
        <Link
          href={`/contact?reason=Request%20briefing%20bundles`}
          style={{ textDecoration: 'none' }}
        >
          <CustomButton
            title="Get in touch"
            backgroundColor="transparent"
            fontColor="#000000"
            size="lg"
            borderColor="#000000"
            margin="10px 0px"
          />
        </Link>
      </Flex>
      <Text
        fontSize="1.6rem"
        fontWeight="700"
        color="#006067"
        textAlign="center"
        my={10}
      >
        Our briefing bundles
      </Text>
      <Text textAlign="center" fontSize="1.1rem" lineHeight="1.7" my={10}>
        Click on the link in each bundle category to view a sample briefing
        within Anders Pink.
      </Text>
      <Flex maxW={720} margin={'0.5rem auto'}>
        <Box width={720}>
          <Select onChange={(e) => setLanguage(e.target.value)}>
            {Object.keys(languages).map((item, index) => (
              <option key={index} value={item}>
                {languages[Object.keys(languages)[index]]}
              </option>
            ))}
          </Select>
        </Box>
      </Flex>
      <Box w="100%" py={5}>
        <Box maxW={720} margin={'1rem auto'}>
          {Object.keys(bundles[language]).map((item, index) => (
            <Accordion key={index} allowToggle>
              <AccordionItem>
                <h2>
                  <AccordionButton>
                    <Box
                      as="span"
                      flex="1"
                      textAlign="left"
                      fontSize="0.9rem"
                      fontWeight="600"
                    >
                      <Text>{item}</Text>
                    </Box>
                    <AccordionIcon />
                  </AccordionButton>
                </h2>
                <AccordionPanel pb={4}>
                  {bundles[language][item].map((res, index) => {
                    return (
                      <>
                        {typeof res === 'object' ? (
                          <Link
                            href={`${res[1]}`}
                            style={{ textDecoration: 'none' }}
                          >
                            <Text
                              _hover={{ color: 'black' }}
                              textDecoration="underline"
                              key={index}
                            >
                              {res[0]}
                            </Text>
                          </Link>
                        ) : (
                          <Text key={index}>{res}</Text>
                        )}
                      </>
                    );
                  })}
                </AccordionPanel>
              </AccordionItem>
            </Accordion>
          ))}
        </Box>
      </Box>
    </Layout>
  );
};

export default ProductBriefingBundles;
